export default "__VITE_ASSET__d049cc3d__"